<template>
  <cs-view single-view />
</template>

<script>
import { CSBase } from '@complispace/cs-design-system';
import { mapState } from 'vuex';

export default {
  extends: CSBase,

  data() {
    return {};
  },

  computed: {
    ...mapState({
      userProfile: (state) => state.authorisation.userProfile
    })
  },

  async mounted() {
    const { state } = this.$route.query;
    const { axiosInstance, stbApiAdapter } = this.$app;
    await this.$store.dispatch('authorisation/validateAndSetUserTokenOrLogout', {
      query: this.$route.query,
      axiosInstance
    });
    await this.$store.dispatch('authorisation/getUserProfile', stbApiAdapter);
    const { id, givenName, familyName, email } = this.userProfile?.userProfile;
    const jwt = await this.$store.dispatch('ahaFeedback/fetchJwt', {
      id,
      firstName: givenName,
      lastName: familyName,
      email
    });
    const callbackUrl = `${process.env.AHA_CALLBACK_URL}?jwt=${jwt}&state=${state}`;
    window.location.href = callbackUrl;
  }
};
</script>
